import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import cn from 'clsx';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import Page from 'components/Page';
import {PaymentSummaryBox} from '../../components/PaymentSummaryBox';
import styles from './styles.module.css';

function BeforeYouLeaveView() {
  const {t} = useTranslation('check-out');
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {isMatch: isMobile} = useScreenResize(DEVICE.laptop);

  return (
    <Page
      className="!mb-[155px] md:!mb-6 checkout-view"
      navBarTitle={t('check_out_short')}
      mainHeader={!isMobile}
      isSubHeaderVisible
      onBackButtonClick={() => {
        navigate(getFullPath(PATHS.home));
      }}
    >
      <div
        className={cn(styles.checkoutView__container, 'checkout-view__container w-full')}
      >
        <div className="w-full checkout-view__container-right">
          <PaymentSummaryBox />
        </div>
      </div>
    </Page>
  );
}

export default BeforeYouLeaveView;
